import { API_CLIENTS_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetApiClientResponseItem
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (value: GetApiClientResponseItem) => void
  onError?: (error: Error) => void
  children?: (value: GetApiClientResponseItem) => ReactElement
  apiAccessId: string
}

const GetApiClientServiceRequest = ({
  apiAccessId,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${API_CLIENTS_SERVICE}/api_clients/${apiAccessId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetApiClientServiceRequest
